import { LogLevel } from "./LogLevel"

export function getLogLevelColor(level: LogLevel): string {
  switch (level) {
    case "Debug":
      return "gray"
    case "Error":
      return "red"
    case "Warning":
      return "yellow"
    case "Information":
      return "var(--mantine-text)"
    default:
      return "var(--mantine-text)"
  }
}

export function getHighestLogLevel(levels: LogLevel[]): LogLevel {
  if (levels.includes("Error")) return "Error"
  if (levels.includes("Warning")) return "Warning"
  if (levels.includes("Debug")) return "Debug"
  return "Information"
}
